import React, {useState, useEffect} from 'react';
import { writeComment, upvoteComment, deleteComment } from "../../../firebase/writeData";
import { getComments } from '../../../firebase/getData'; 
import { useAuthState } from 'react-firebase-hooks/auth';
import { firebase } from "../../../firebase/firebaseConfig";
import AddComment from "./AddComment";
import LoadComments from "./LoadComments";
import {NavLink} from "react-router-dom";

//UI Imports
import {Button} from 'react-bootstrap';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
var cloneDeep = require('lodash.clonedeep');


export default function ModalComments(props) {
  const [user] = useAuthState(firebase.auth());
  const [error, setError] = useState(false);
  const [comments, setComments] = useState(null);
  const [lastComment, setLastComment] = useState(null);

  useEffect(() =>  getComments({setState: setComments, postID: props.postID, setLastComment}), []) // First render

  const commentUpvote = (comment) => {
    const {upvoters, upvotes, commentID} = comment;
    const postID = props.postID;

    if (user) {
      if (upvoters.length !== 0 && upvoters[0] !== "" && upvoters.includes(user.uid)) {
        upvoteComment({upvote: -1, authorID: user.uid, postID, commentID, upvoters, upvotes});
        let newComments = cloneDeep(comments);
        newComments.forEach((comm) => {
          if (comm.commentID === commentID) {
            comm.upvotes = comm.upvotes - 1;
            comm.upvoters = comm.upvoters.filter((author) => author !== user.uid);
          }
        })
        setComments(newComments);
      } else {
        upvoteComment({upvote: 1, authorID: user.uid, postID, commentID, upvoters, upvotes});
        let newComments = cloneDeep(comments);
        newComments.forEach((comm) => {
          if (comm.commentID === commentID) {
            comm.upvotes = comm.upvotes + 1;
            comm.upvoters = [...comm.upvoters, user.uid];
          }
        })
        setComments(newComments);
      }
    } else setError(true);
  }

  const createNewComment = (description) => {
    if(user) {
      writeComment({postID: props.postID, description, comments, setComments, summary: props.postSummary, postOwner: props.postOwner});
    } else setError(true);
  }

  const commentDelete = (commentRef) => {
    if (commentRef.authorID === user.uid) {
      deleteComment(props.postID, commentRef.commentID, user.uid);
      const newComments = cloneDeep(comments).filter((comm) => comm.commentID !== commentRef.commentID);
      setComments(newComments);
    }
  }

  let commentsList = [];
  if (comments) { 
    comments.forEach((comment) => {
      let formattedDate = comment.date.toDateString();
      formattedDate = formattedDate.substring(formattedDate.indexOf(" ") + 1);
      let author = false;
      if (comment.upvoters.length !== 0 && comment.upvoters[0] !== "" && user && comment.upvoters.includes(user.uid)) author = true; 

      commentsList.push(
      <div className="individual-comment mb-4" key={comment.commentID}>
        <div className="d-flex justify-content-between">
          <span className="font-weight-bold mr-auto"><NavLink to={`/users/${comment.authorID}`}>{comment.authorName}</NavLink></span>
          {user && comment.authorID === user.uid && <Button variant= "danger" className="mr-3" onClick={() => commentDelete(comment)}>Delete</Button>}
          <Button variant={author ? "success" : "outline-success"} onClick={() => commentUpvote(comment)}>+{comment.upvotes}</Button>
        </div>
        <p className="comment-date">{formattedDate}</p>
        <p className="comment-description">{comment.description}</p>
      </div>
      );
    });
  }

  return (
    <div className="px-4 pb-4">
    <h5 className="mt-4">Comments</h5>
    <div className="modal-comments-section">
      <AddComment createNewComment={createNewComment} />
      {commentsList && (commentsList.length > 0) && <hr className="mb-4" style={ {margin: "0 10px 0 10px", borderColor: "#000"} }/>}
      {commentsList}
      {commentsList && (commentsList.length > 0) && <LoadComments comments={comments} setComments={setComments} postID={props.postID} lastComment={lastComment} setLastComment={setLastComment}/>}
    </div>

      <Snackbar 
        open={error} 
        autoHideDuration={3000} 
        onClose={() => setError(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        key={'topcenter'}
        >
        <MuiAlert elevation={6} variant="filled" severity="error">
          Please sign in to comment or upvote. 
        </MuiAlert>
      </Snackbar>
    </div>
  )
}
